import hdrm from '../../hdrm';

export default (...args) => hdrm.verifiers.hasElementAttribute(...args);
